import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

//Report
import CancelledBookings from '../Reports/Flight/CancelledBookings';
import AllTransactionsReport from '../Reports/Flight/AllTransactions';
import LowfareflightReport from '../Reports/Flight/LowFareFlight';
import SaleSummaryReport from '../Reports/Flight/SaleSummary';
import UnflownTicketReport from '../Reports/Flight/UnflownTicket';
import ReportsHotelTransactions from '../Reports/Hotel/AllTransactions';
import ReportsBusTransactions from '../Reports/Bus/AllTransactions';
import ReportsCabTransactions from '../Reports/Cab/AllTransactions';
import ReportsVisaTransactions from '../Reports/Visa/AllTransactions';
import ReportsForexTransactions from '../Reports/Forex/AllTransactions';
import ReportsInsuranceTransactions from '../Reports/Insurance/AllTransactions';
import ReportsTrainTransactions from '../Reports/Train/AllTransactions';


//Reservation
import ReservationFligthTransactions from '../Reservations/Flight/AllTransactions';
import ReservationTransactionDetails from '../Reservations/Flight/TransactionDetails';

import ReservationCabTransactions from '../Reservations/Cab/AllTransactions';
import ReservationHotelTransactions from '../Reservations/Hotel/AllTransactions';
import ReservationTrainTransactions from '../Reservations/Train/AllTransactions';
import ReservationVisaTransactions from '../Reservations/Visa/AllTransactions';
import ReservationForexTransactions from '../Reservations/Forex/AllTransactions';
import ReservationInsuranceTransactions from '../Reservations/Insurance/AllTransactions';

import Home from '../External/Home';
import About from '../External/About';
import Contact from '../External/Contact';
import PrivacyPolicy from '../External/PrivacyPolicy';
import TermsofService from '../External/TermsofService';
import PaymentSecurity from '../External/PaymentSecurity';


import Flight from '../Products/Flight/Flight';
import Result from '../Products/Flight/Result';
import MultiCity from '../Products/Flight/MultiCityResult';

import Booking from '../Products/Flight/Booking';
import Dashboard from '../Dashboard/Dashboard';
import MyBooking from '../Dashboard/MyBooking';
import BookingDetails from '../Dashboard/BookingDetails';

import Hotel from '../Products/Hotel/Hotel';
import Results from '../Products/Hotel/Results';
import Availability from '../Products/Hotel/Availability';
import HotelDetail from '../Products/Hotel/HotelDetail';
import HotelBooking from '../Products/Hotel/HotelBooking';
import CheckOut from '../Products/Hotel/CheckOut';
import ThankYou from "../Products/Hotel/ThankYou";

import Bus from '../Products/Bus/Bus';
import List from '../Products/Bus/List';
import BusPayment from '../Products/Bus/BusPayment';
import BusBooking from '../Products/Bus/BusBooking';
import SeatLayout from '../Products/Bus/SeatLayout';

import Insurance from '../Products/Insurance/Insurance';
import Insresult from '../Products/Insurance/Insresult';
import InsBooking from '../Products/Insurance/InsBooking';

import Cabs from '../Products/Cabs/Cabs';
import Visa from '../Products/Visa/Visa';
import Forex from '../Products/Forex/Forex';

import Rail from '../Products/Rail/Rail';

import AgentDetails from '../Identity/AgentDetails';
import Thankyou from '../Products/Flight/Thankyou';
import ThankyouBus from '../Products/Bus/Thankyou'

import Settings from '../Settings/Settings';
import ManageMarkup from '../Settings/ManageMarkup';
import UserAdmin from '../Settings/UserAdmin';
import Myprofile from '../Settings/Myprofile';
import ChangePassword from '../Settings/ChangePassword';

import CustomerInvoice from '../Reservations/Flight/CustomerInvoice';
import AgencyInvoice from '../Reservations/Flight/AgencyInvoice';
import ReSchedule from '../Reservations/Flight/ReSchedule';
import CancellationBooking from '../Reservations/Flight/CancellationBooking';
import PrintInvoice from '../Reservations/Flight/PrintInvoice';
import PrintTicket from '../Reservations/Flight/PrintTicket';
import Approval from '../Dashboard/Approval';
import ApprovalDetail from '../Dashboard/ApprovalDetail';
import TripQueue from '../Dashboard/TripQueue';
import TripQueueDetail from '../Dashboard/TripQueueDetail';

import PersonalInformation from '../MyProfile/PersonalInformation';
import OrganizationProfile from '../MyProfile/OrganizationProfile';
import ContactDetails from '../MyProfile/ContactDetails';
import Documents from '../MyProfile/Documents';
import Preferences from '../MyProfile/Preferences';
import ReportingParameters from '../MyProfile/ReportingParameters';


import ReservationBusTransactions from '../Reservations/Bus/AllTransactions';
import ReservationBusEnquiryTransactions from '../Reservations/Bus/AllEnquiryTransactions';
import BusTransactionsDetails from '../Reservations/Bus/TransactionsDetails'
import BusCustomerInvoice from '../Reservations/Bus/BusCustomerInvoice'
import BusAgencyInvoice from '../Reservations/Bus/BusAgencyInvoice'
import BusRescheduleTicket from '../Reservations/Bus/BusRescheduleTicket'
import BusCancellationBooking from '../Reservations/Bus/CancellationBooking'
import BusPrintInvoice from '../Reservations/Bus/PrintInvoice'
import BusPrintTicket from '../Reservations/Bus/BusPrintTicket'

import CabTransactionsDetails from '../Reservations/Cab/CabTransactionsDetails'
import TrainTransactionsDetails from '../Reservations/Train/TrainTransactionsDetails'
import VisaTransactionsDetails from '../Reservations/Visa/VisaTransactionsDetails'
import ForexTransactionsDetails from '../Reservations/Forex/ForexTransactionsDetails'
// import InsuranceTransactionsDetails from '../Reservations/Insurance/InsuranceTransactionsDetails'
import InsThankyou from '../Products/Insurance/InsThankyou';
import InsTransactionsDetails from '../Reservations/Insurance/InsTransactionsDetails'
import InsCancellationBooking from '../Reservations/Insurance/InsCancellationBooking'
import InsPrintInvoice from '../Reservations/Insurance/InsPrintInvoice'

import ReservationHotelEnquiryTransactions from "../Reservations/Hotel/AllEnquiryTransactions";
import HotelTransactionsDetails from "../Reservations/Hotel/TransactionsDetails";
import HotelCustomerInvoice from "../Reservations/Hotel/HotelCustomerInvoice";
import HotelAgencyInvoice from "../Reservations/Hotel/HotelAgencyInvoice";
import HotelCancellationBooking from "../Reservations/Hotel/CancellationBooking";
import HotelPrintInvoice from "../Reservations/Hotel/PrintInvoice";
import HotelPrintTicket from "../Reservations/Hotel/HotelPrintTicket";
import HotelCancelledBookings from "../Reports/Hotel/CancelledBookings";
import LowFareHotels from "../Reports/Hotel/LowFareHotels";

import HdfcPaymentResponse from '../Payment/HdfcPaymentResponse';
const Layout = () => {

  return (
    <>
      {/* HEADER can be here */}

      <Routes>

        {/* INTERNAL LOGGED-IN ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsofService />} />
        <Route path="/payment-security" element={<PaymentSecurity />} />

        <Route path="/flight" element={<Flight />} />
        <Route path="/flight/result" element={<Result />} />
        <Route path="/flight/multicity" element={<MultiCity />} />
        <Route path="/flight/booking" element={<Booking />} />

        {/* Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/mybooking" element={<MyBooking />} />
        <Route path="/dashboard/bookingDetails" element={<BookingDetails />} />
        <Route path="/approval" element={<Approval />} />
        <Route path="/dashboard/approval/Approval-detail" element={<ApprovalDetail />} />
        <Route path="/dashboard/TripQueue" element={<TripQueue />} />
        <Route path="/dashboard/TripQueue/TripQueuedetail" element={<TripQueueDetail />} />

        {/* My Profile */}
        <Route path="/my-profile/personal-information" element={<PersonalInformation />} />
        <Route path="/my-profile/organization-profile" element={<OrganizationProfile />} />
        <Route path="/my-profile/contact-details" element={<ContactDetails />} />
        <Route path="/my-profile/documents" element={<Documents />} />
        <Route path="/my-profile/preferences" element={<Preferences />} />
        <Route path="/my-profile/reporting-parameters" element={<ReportingParameters />} />

        {/* Hotel */}
        <Route path="/hotel" element={<Hotel />} />
        <Route path="/hotel/result" element={<Results />} />
        <Route path="/availability" element={<Availability />} />
        <Route path="/hotel/hoteldetail" element={<HotelDetail />} />
        <Route path="/hotel/hotelbooking" element={<HotelBooking />} />
        <Route path="/hotel/checkout" element={<CheckOut />} />
        <Route path="/hotel/thankyou" element={<ThankYou />} />

        {/* Others */}
        <Route path="/bus" element={<Bus />} />
        <Route path="/bus/list" element={<List />} />
        <Route path="/bus/BusBooking" element={<BusBooking />} />
        <Route path="/bus/BusPayment" element={<BusPayment />} />
        <Route path="/bus/seat-layout" element={<SeatLayout />} />

        {/* Others */}
        <Route path="/cabs" element={<Cabs />} />
        <Route path="/visa" element={<Visa />} />
        <Route path="/forex" element={<Forex />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/insurance/results" element={<Insresult />} />
        <Route path="/insurance/booking" element={<InsBooking />} />
        <Route path="/insurance/Thankyou" element={<InsThankyou />} />

        <Route path="/rail" element={<Rail />} />

        {/* Reports */}
        <Route path="/reports/flight/alltransactions" element={<AllTransactionsReport />} />
        <Route path="/reports/flight/lowfareflightreport" element={<LowfareflightReport />} />
        <Route path="/reports/flight/cancelledbookings" element={<CancelledBookings />} />
        <Route path="/reports/flight/salesummary" element={<SaleSummaryReport />} />
        <Route path="/reports/flight/unflownticket" element={<UnflownTicketReport />} />
        <Route path="/reports/hotel/alltransactions" element={<ReportsHotelTransactions />} />
        <Route path="/reports/bus/alltransactions" element={<ReportsBusTransactions />} />
        <Route path="/reports/cab/alltransactions" element={<ReportsCabTransactions />} />
        <Route path="/reports/train/alltransactions" element={<ReportsTrainTransactions />} />
        <Route path="/reports/visa/alltransactions" element={<ReportsVisaTransactions />} />
        <Route path="/reports/forex/alltransactions" element={<ReportsForexTransactions />} />
        <Route path="/reports/insurance/alltransactions" element={<ReportsInsuranceTransactions />} />


        {/* Reservations */}
        <Route path="/reservations/flight/alltransactions" element={<ReservationFligthTransactions />} />
        <Route path="/reservations/flight/transactiondetails" element={<ReservationTransactionDetails />} />
        <Route path="/reservations/flight/customerinvoice" element={<CustomerInvoice />} />
        <Route path="/reservations/flight/agencyinvoice" element={<AgencyInvoice />} />
        <Route path="/reservations/flight/ReSchedule" element={<ReSchedule />} />
        <Route path="/reservations/flight/CancellationBooking" element={<CancellationBooking />} />
        <Route path="/reservations/flight/PrintInvoice" element={<PrintInvoice />} />
        <Route path="/reservations/flight/PrintTicket" element={<PrintTicket />} />

        <Route path="/reservations/bus/alltransactions" element={<ReservationBusTransactions />} />
        <Route path="/reservations/bus/allenquirytransactions" element={<ReservationBusEnquiryTransactions />} />
        <Route path="/reservations/bus/TransactionsDetails" element={<BusTransactionsDetails />} />
        <Route path="/reservations/bus/BusCustomerInvoice" element={<BusCustomerInvoice />} />
        <Route path="/reservations/bus/BusAgencyInvoice" element={<BusAgencyInvoice />} />
        <Route path="/reservations/bus/BusRescheduleTicket" element={<BusRescheduleTicket />} />
        <Route path="/reservations/bus/CancellationBooking" element={<BusCancellationBooking />} />
        <Route path="/reservations/bus/PrintInvoice" element={<BusPrintInvoice />} />
        <Route path="/reservations/bus/BusPrintTicket" element={<BusPrintTicket />} />


        <Route path="/reservations/cab/alltransactions" element={<ReservationCabTransactions />} />
        <Route path="/reservations/cab/TransactionsDetails" element={<CabTransactionsDetails />} />


        <Route path="/reservations/train/alltransactions" element={<ReservationTrainTransactions />} />
        <Route path="/reservations/train/TransactionsDetails" element={<TrainTransactionsDetails />} />

        <Route path="/reservations/visa/alltransactions" element={<ReservationVisaTransactions />} />
        <Route path="/reservations/visa/TransactionsDetails" element={<VisaTransactionsDetails />} />

        <Route path="/reservations/forex/alltransactions" element={<ReservationForexTransactions />} />
        <Route path="/reservations/forex/TransactionsDetails" element={<ForexTransactionsDetails />} />

        <Route path="/reservations/insurance/alltransactions" element={<ReservationInsuranceTransactions />} />
        <Route path="/reservations/insurance/TransactionsDetails" element={<InsTransactionsDetails />} />
        <Route path="/reservations/insurance/InsCancellationBooking" element={<InsCancellationBooking />} />
        <Route path="/reservations/insurance/InsPrintInvoice" element={<InsPrintInvoice />} />

        {/* Hotel Reservations */}
        <Route path="/reservations/hotel/alltransactions" element={<ReservationHotelTransactions />} />
        <Route path="/reservations/hotel/allenquirytransactions" element={<ReservationHotelEnquiryTransactions />} />
        <Route path="/reservations/hotel/TransactionsDetails" element={<HotelTransactionsDetails />} />
        <Route path="/reservations/hotel/HotelCustomerInvoice" element={<HotelCustomerInvoice />} />
        <Route path="/reservations/hotel/HotelAgencyInvoice" element={<HotelAgencyInvoice />} />

        <Route path="/reservations/hotel/CancellationBooking" element={<HotelCancellationBooking />} />
        <Route path="/reservations/hotel/PrintInvoice" element={<HotelPrintInvoice />} />
        <Route path="/reservations/hotel/PrintTicket" element={<HotelPrintTicket />} />
        <Route path="/Reports/Hotel/lowfarehotels" element={<LowFareHotels />} />
        <Route path="/Reports/Hotel/CancelledBookings"  element={<HotelCancelledBookings />}  />


        {/* Settings */}
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/manage" element={<ManageMarkup />} />
        <Route path="/settings/useradmin" element={<UserAdmin />} />
        <Route path="/settings/myprofile" element={<Myprofile />} />
        <Route path="/settings/changepassword" element={<ChangePassword />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/bus/thankyou" element={<ThankyouBus />} />
        <Route path="/agent-details" element={<AgentDetails />} />
        <Route path="/HdfcPaymentResponse" element={<HdfcPaymentResponse />} />

      </Routes>

      {/* FOOTER can be here */}

    </>
  );
};

export default Layout;
